import { WEEKPLAN } from "../config"
import WinHeaderCopy from "./WinHeaderCopy"

interface FiveFourTileWinProps {
	debugDay?: number
}

const FiveFourTileWin: React.FC<FiveFourTileWinProps> = ({ debugDay = null }) => {
	const d = new Date()

	let dayContent

	if (typeof debugDay === "number") {
		dayContent = WEEKPLAN.filter(weekday => weekday.getDay === debugDay)[0]
	} else {
		dayContent = WEEKPLAN.filter(weekday => weekday.getDay === d.getDay())[0]
	}

	return (
		<>
			{/* Mobile */}
			<div
				className={"relative lg:hidden  bg-center w-full h-[488px] lg:h-auto bg-cover"}
				style={{ backgroundImage: "url(images/providers/" + dayContent.provider + "-mobile.webp)" }}
			>
				<div className="mx-auto max-w-6xl px-4 py-12 pt-6 lg:pt-12">
					<h2 className="h2 calenderCopyShadow">Yeah! Gewonnen!</h2>

					<WinHeaderCopy debugWin={debugDay} />

					{/* <div className="grid grid-cols-[235px_1fr] gap-6">
						<div className="w-[142px] lg:w-1/3 absolute left-[5%] bottom-[3%] h-[26.6%] bg-[url(/public/images/boxHeute.png)] bg-contain bg-no-repeat">
							<svg className="absolute top-[46%] left-0 w-full" viewBox="0 0 332 130" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
								<text x="50%" y="22%" dominantBaseline="middle" textAnchor="middle" fontFamily="Amsi" fontSize={50} className="font-Amsi uppercase fill-red ">
									Immer
								</text>
								<text x="50%" y="62%" dominantBaseline="middle" textAnchor="middle" fontFamily="Amsi" fontSize={50} className="font-Amsi uppercase fill-red ">
									{dayContent.day}s
								</text>
							</svg>
						</div>
					</div> */}
				</div>
			</div>
			{/* Desktop */}
			<div className={"relative  hidden lg:block bg-cover bg-center"} style={{ backgroundImage: "url(images/providers/" + dayContent.provider + ".webp)" }}>
				<div className="mx-auto max-w-6xl px-4 py-12">
					<h2 className="h2 calenderCopyShadow text-left">Yeah! Gewonnen!</h2>

					<WinHeaderCopy debugWin={debugDay} />

					<div className="h-[235px]"></div>
					{/* <div className="grid grid-cols-[235px_1fr] gap-6">
						<div className="w-full top-[-25px] relative h-[235px] bg-[url(/public/images/boxHeute.png)] bg-contain bg-no-repeat">
							<svg className="absolute top-[46%] left-0 w-full" viewBox="0 0 332 130" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
								<text x="50%" y="22%" dominantBaseline="middle" textAnchor="middle" fontFamily="Amsi" fontSize={50} className="font-Amsi uppercase fill-red ">
									Immer
								</text>
								<text x="50%" y="62%" dominantBaseline="middle" textAnchor="middle" fontFamily="Amsi" fontSize={50} className="font-Amsi uppercase fill-red ">
									{dayContent.day}s
								</text>
							</svg>
						</div>
					</div> */}
				</div>
			</div>
		</>
	)
}

export default FiveFourTileWin
